import styled from 'styled-components';
import publicationPattern from '../../images/publication-pattern.svg';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width:100%;
  height: 200px;
`;

export const HeaderBackground = styled.div`  
  background-position: left;
  background-size: auto 100%;
`;

export const HeaderBackgroundContainer = styled.div`  
  background-position: left;
  background-size: auto 100%;
  background-color: ${(props) => props.theme['color.blueDark']};
  background-image: url(${publicationPattern});
`;

export const HeaderTitle = styled.div`
  font-size: 32px;
  padding: 0 40px;
  display: block;
  padding-bottom: 3px;
  flex: 0 1 auto;
  margin: 10px 10px 10px 0px;
  color: #fff;
  line-height: 1.1;
`;

export const FeatureContainer = styled.div`
  display: grid;
  grid-template-columns: 12fr;
  margin-bottom: 20px;
`;

export const AddButton = styled.div`
  grid-column: -1;
`;

export const EmptyPublication = styled.div`
>div>span{
  margin-bottom: 30px;
}
`;
